import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { FiscalDeviceEventKind, FiscalDeviceEventStatus } from '@skylab-shared/dataModel';
import { convertUTCDateToLocalDate, fillPlaceholders } from '@skylab-shared/utils';

export type FiscalDeviceRegistryCreateEventData = {
    readonly deviceId: number;
	readonly data: {
		description: string;
		status: FiscalDeviceEventStatus
	} & ({
		kind: FiscalDeviceEventKind.DocumentFiscalization;
		documentId: number;
	} | {
		kind: FiscalDeviceEventKind.DailyReportPrinting;
	})
};

export type FiscalDeviceRegistryEventResponse = {
	object: {
		id: number,
		version: string
	}
};

export class FiscalDeviceRegistryCreateEventCommand extends Command<FiscalDeviceRegistryCreateEventData, FiscalDeviceRegistryEventResponse> { }

export class FiscalDeviceRegistryCreateEventCommandHandlerBase implements CommandHandler<FiscalDeviceRegistryCreateEventCommand, FiscalDeviceRegistryCreateEventData, FiscalDeviceRegistryEventResponse> {
    private static Url = TaggedUrl.join('system/devices/:deviceId/events', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: FiscalDeviceRegistryCreateEventCommand): Promise<FiscalDeviceRegistryEventResponse> {
        const { data } = await this.http.post(fillPlaceholders(FiscalDeviceRegistryCreateEventCommandHandlerBase.Url, { deviceId: command.params?.deviceId }), {...command.params?.data, date: convertUTCDateToLocalDate()});

        return data;
    }
}
